import { connect } from 'react-redux';

import { userLogin as userLoginAction } from './Auth.saga';
import Login from './Login';

const mapDispatchToProps = {
  userLogin: userLoginAction,
};

function mergeProps(stateProps, dispatchProps) {
  const { redirect, ...restStateProps } = stateProps;
  const { userLogin } = dispatchProps;
  return {
    ...restStateProps,
    handleSubmit: (formValues, formAsyncFns) => userLogin({ ...formValues, redirect }, formAsyncFns),
  };
}

export default connect(null, mapDispatchToProps, mergeProps)(Login);
